import React from 'react';
import { Link } from 'react-router-dom';
import { StaticPageLayout } from './StaticPageLayout';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../../utils/contactInfo';
import styles from './NotFound.module.scss';

export const NotFound: React.FC = () => {
  return (
    <StaticPageLayout title="Page not found">
      <div className={styles.wrap}>
        <p className={styles.code} aria-hidden="true">404</p>
        <h2 className={styles.heading}>We couldn't find that page</h2>
        <p className={styles.body}>
          The link may be broken, or the page may have moved. Try one of the options below.
        </p>
        <div className={styles.actions}>
          <Link to="/" className={styles.primary}>Go home</Link>
          <Link to="/login" className={styles.secondary}>Sign in</Link>
        </div>
        <p className={styles.contact}>
          Still stuck? Email <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
        </p>
      </div>
    </StaticPageLayout>
  );
};
